import Joyride, { ACTIONS, EVENTS, STATUS } from 'react-joyride';
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import { GuidedTourTooltip } from './GuidedTourTooltip/GuidedTourTooltip';

const defaultOptions = {
  overlayColor: 'rgba(0, 0, 0, 0.7)',
  height: '120px',
  zIndex: 5000
};

export const GuidedTour = props => {
  const { locale, steps, onTourComplete } = props;

  const handleCallbacks = useCallback(
    data => {
      const { action, status } = data;
      if (action === ACTIONS.CLOSE || status === STATUS.FINISHED) {
        onTourComplete(true);
      }
    },
    [onTourComplete]
  );

  return (
    <Joyride
      hideCloseButton
      continuous
      showSkipButton
      disableOverlayClose
      run
      steps={steps}
      styles={{ options: defaultOptions }}
      callback={handleCallbacks}
      tooltipComponent={GuidedTourTooltip}
      locale={locale}
    />
  );
};

GuidedTour.defaultProps = {
  steps: [],
  locale: null
};

GuidedTour.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  locale: PropTypes.object,
  // TODO: Fix this - like the object above, we have to specify what is in this Array...
  // eslint-disable-next-line react/forbid-prop-types
  steps: PropTypes.array,
  onTourComplete: PropTypes.func.isRequired
};

export { ACTIONS, EVENTS, STATUS };

export default GuidedTour;
